"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupArticle = exports.FAQList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Popup = require("../Popup");
var _RichText = require("../RichText");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _useTracking2 = require("../../hooks/useTracking");
var _uiOptimisationRecommenderRightArrow = _interopRequireDefault(require("../../assets/images/ui-optimisation-recommender-right-arrow.svg"));
var _LocaleProvider = require("../LocaleProvider");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var FAQList = function FAQList(props) {
  var faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    onClickFaq = props.onClickFaq,
    disabledFaq = props.disabledFaq,
    _props$isInDetail = props.isInDetail,
    isInDetail = _props$isInDetail === void 0 ? false : _props$isInDetail,
    useUIOptimisationRecommender = props.useUIOptimisationRecommender;
  var renderFAQItem = function renderFAQItem(faq, index) {
    // tracker
    var _useTracking = (0, _useTracking2.useTracking)({
        trackingData: props.trackingData,
        componentData: _objectSpread(_objectSpread({}, faq), {}, {
          location: index
        })
      }),
      trackingClick = _useTracking.trackingClick,
      trackingImpressionProps = _useTracking.trackingImpressionProps;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _clsx3.default)((0, _getPrefixCls.getPrefixCls)('article-faq-item'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('article-faq-item__disabled'), disabledFaq)),
      onClick: function onClick() {
        // trackingClick && tracker.click(trackingClick);
        // 因为需要在点击时添加 next_chat_dialogue_id 这个 id 需要请求后才获得，所以把相应参数传回 C 端，那里触发点击上报
        onClickFaq === null || onClickFaq === void 0 ? void 0 : onClickFaq(faq, {
          trackingData: trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data,
          isInDetail: isInDetail
        });
      }
    }, trackingImpressionProps), useUIOptimisationRecommender ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('article-faq-item-text')
    }, faq.text), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
      src: _uiOptimisationRecommenderRightArrow.default,
      style: {
        width: 12,
        height: '100%',
        marginLeft: 8
      }
    })) : faq.text);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, faqIntentList !== null && faqIntentList !== void 0 && faqIntentList.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)((0, _getPrefixCls.getPrefixCls)('article-faq-container'), useUIOptimisationRecommender ? (0, _getPrefixCls.getPrefixCls)('article-ui-optimisation') : '')
  }, faqTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('article-faq-title')
  }, faqTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('article-faq-list')
  }, faqIntentList.map(renderFAQItem))) : null);
};
exports.FAQList = FAQList;
var PopupArticle = function PopupArticle(props) {
  var zIndex = props.zIndex,
    title = props.title,
    active = props.active,
    content = props.content,
    closeButtonText = props.closeButtonText,
    onClose = props.onClose,
    changeTrackCloseArticleContentData = props.changeTrackCloseArticleContentData,
    articleContentTrackingData = props.articleContentTrackingData,
    disableSpecialLink = props.disableSpecialLink,
    showExpandIcon = props.showExpandIcon,
    unreadObj = props.unreadObj,
    isScrollToUnread = props.isScrollToUnread,
    _props$exceededMaxHei = props.exceededMaxHeight,
    exceededMaxHeight = _props$exceededMaxHei === void 0 ? false : _props$exceededMaxHei,
    unreadText = props.unreadText,
    isSeparate = props.isSeparate,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    disabledFaq = props.disabledFaq,
    trackingData = props.trackingData,
    onClickFaq = props.onClickFaq,
    isOldUI = props.isOldUI,
    useUIOptimisationRecommender = props.useUIOptimisationRecommender,
    isUIOptimisationAccordion = props.isUIOptimisationAccordion,
    _props$uiOptimisation = props.uiOptimisationAccordionOptions,
    defaultUIOptimisationAccordionOptions = _props$uiOptimisation === void 0 ? {} : _props$uiOptimisation,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationTable = props.isUIOptimisationTable,
    className = props.className;
  var uiOptimisationAccordionOptions = isUIOptimisationAccordion ? _objectSpread(_objectSpread({}, defaultUIOptimisationAccordionOptions), {}, {
    html: content,
    expand: true,
    isUIOptimisationAccordion: isUIOptimisationAccordion
  }) : undefined;
  var scrollTo = function scrollTo(element, finalHeight, duration) {
    if (duration <= 0) {
      return;
    }
    var distance = finalHeight - element.scrollTop;
    var perTick = distance / duration * 10;
    setTimeout(function () {
      element.scrollTop = element.scrollTop + perTick;
      if (element.scrollTop === finalHeight) {
        return;
      }
      scrollTo(element, finalHeight, duration - 10);
    }, 0);
  };
  var isListWrapper = function isListWrapper(childElement) {
    return childElement.tagName.toLowerCase() === 'ol' || childElement.tagName.toLowerCase() === 'ul';
  }; // 添加unread分割线

  var addUnread = function addUnread(exceededMaxHeight, richTextElement, scrollElement, index, listWrapperOffsetTop) {
    var childElements = Array.from(richTextElement.children);
    var childElement = childElements.at(index);
    console.log('__addUnread', childElement, index);
    if (childElement && isListWrapper(childElement) && (unreadObj === null || unreadObj === void 0 ? void 0 : unreadObj.listIndex) !== undefined) {
      var _childElement$parentN;

      // 创建一个position:relative的div包裹ol标签, 便于unread分割线使用absolute
      var olWrapperElement = document.createElement('div');
      olWrapperElement.style.position = 'relative';
      (_childElement$parentN = childElement.parentNode) === null || _childElement$parentN === void 0 ? void 0 : _childElement$parentN.insertBefore(olWrapperElement, childElement);
      olWrapperElement.appendChild(childElement);
      addUnread(exceededMaxHeight, childElement, scrollElement, (unreadObj === null || unreadObj === void 0 ? void 0 : unreadObj.listIndex) || 0, olWrapperElement.offsetTop);
      return;
    }
    if (childElement && (index > 0 || listWrapperOffsetTop || !exceededMaxHeight)) {
      // 添加unread分割线
      var unreadMarker = "\n      <div style=\"height: 48px; padding: 4px 0;\" class=\"ChatbotUI-popup-content-unread\">\n          <div style=\"".concat((unreadObj === null || unreadObj === void 0 ? void 0 : unreadObj.listIndex) !== undefined ? 'position: absolute;left: 0;right: 0;' : '', "padding-top: 12px;display: flex;align-items: center;\">\n            <div style=\"flex-grow: 1; border-top: 0.5px solid rgba(0, 0, 0, 0.09);\"></div>\n            <div style=\"font-size: 14px !important;font-weight: 500;line-height: 16px;color: rgba(0, 0, 0, 0.54);padding: 0 8px\">").concat(unreadText, "</div>\n            <div style=\"flex-grow: 1; border-top: 0.5px solid rgba(0, 0, 0, 0.09);\"></div>\n          </div>\n      </div>");
      var childNodes = childElement.childNodes; // 如果内容只有一个<br />换行, unread分割线需要加在换行的下方, 其他情况加在上方

      var hasOnlyBrChild = childNodes.length === 1 && childNodes[0] instanceof HTMLBRElement;
      childElement.insertAdjacentHTML(hasOnlyBrChild || !exceededMaxHeight ? 'afterend' : 'beforebegin', unreadMarker);
      var unreadLineOffsetTop = scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.querySelector('.ChatbotUI-popup-content-unread').offsetTop; // 滚动距离是unread分割线距离弹出框顶部的距离，需要去掉弹出框的marginTop值

      var scrollElementMarginTop = parseFloat(getComputedStyle(scrollElement).marginTop); // 由于ol/ul标签外层有包裹一个div, unreadLineOffsetTop是unread分隔线距离该div的距离，需要加上 listWrapperOffsetTop 得到真实滚动距离

      var scrollHeight = unreadLineOffsetTop - scrollElementMarginTop + (listWrapperOffsetTop || 0);
      setTimeout(function () {
        scrollTo(scrollElement, scrollHeight, 400);
      }, 900);
    }
  };
  (0, _react.useEffect)(function () {
    var isAccordionScroll = isUIOptimisationAccordion && typeof (uiOptimisationAccordionOptions === null || uiOptimisationAccordionOptions === void 0 ? void 0 : uiOptimisationAccordionOptions.accordionIndex) === 'number' && (uiOptimisationAccordionOptions === null || uiOptimisationAccordionOptions === void 0 ? void 0 : uiOptimisationAccordionOptions.accordionIndex) >= 0 && typeof (uiOptimisationAccordionOptions === null || uiOptimisationAccordionOptions === void 0 ? void 0 : uiOptimisationAccordionOptions.accordionItemIndex) === 'number' && (uiOptimisationAccordionOptions === null || uiOptimisationAccordionOptions === void 0 ? void 0 : uiOptimisationAccordionOptions.accordionItemIndex) >= 0;
    if (active && isScrollToUnread && !isAccordionScroll) {
      setTimeout(function () {
        var _document;
        var scrollElement = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector('.ChatbotUI-modal-popup-content');
        var richTextElement = scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.querySelector('.ChatbotUI-rich-text-content');
        addUnread(exceededMaxHeight, richTextElement, scrollElement, unreadObj.index);
      }, 100);
    } // 滚动到 指定的 手风琴

    if (active && isAccordionScroll) {
      // 这里参照上面的逻辑
      setTimeout(function () {
        var _document2;
        var scrollElement = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.querySelector('.ChatbotUI-modal-popup-content');
        if (scrollElement) {
          scrollElement.querySelectorAll('accordion-block').forEach(function (item, index) {
            if (index === (uiOptimisationAccordionOptions === null || uiOptimisationAccordionOptions === void 0 ? void 0 : uiOptimisationAccordionOptions.accordionIndex)) {
              var top = (item === null || item === void 0 ? void 0 : item.offsetTop) - 40;
              if (top) {
                scrollTo(scrollElement, top, 300);
              }
            }
          });
        }
      }, 100);
    }
  }, [active]);
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  return /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    className: className || '',
    showCloseIcon: true,
    zIndex: zIndex,
    closeButtonText: closeButtonText,
    active: active,
    title: isOldUI ? trans('article_title') : '',
    onClose: onClose,
    contentContainerClassName: isOldUI ? (0, _getPrefixCls.getPrefixCls)('article-popup-content') : (0, _getPrefixCls.getPrefixCls)('article-popup-content-autoheight'),
    contentClassName: isOldUI ? (0, _getPrefixCls.getPrefixCls)('modal-article') : undefined,
    titleClassName: isOldUI ? (0, _getPrefixCls.getPrefixCls)('modal-article-title') : undefined
  }, isOldUI ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)((0, _getPrefixCls.getPrefixCls)('old-ui-article-detail'), isUIOptimisationTable && (0, _getPrefixCls.getPrefixCls)('article-detail-ui-optimisation-table'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('content-article-title')
  }, title), /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    onClose: onClose,
    content: content,
    changeTrackCloseArticleContentData: changeTrackCloseArticleContentData,
    articleContentTrackingData: articleContentTrackingData,
    disableSpecialLink: !!disableSpecialLink,
    showExpandIcon: showExpandIcon,
    uiOptimisationAccordionOptions: uiOptimisationAccordionOptions,
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableModal: isUIOptimisationTable
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)((0, _getPrefixCls.getPrefixCls)('article-detail'), isUIOptimisationTable && (0, _getPrefixCls.getPrefixCls)('article-detail-ui-optimisation-table'))
  }, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    onClose: onClose,
    content: content,
    changeTrackCloseArticleContentData: changeTrackCloseArticleContentData,
    articleContentTrackingData: articleContentTrackingData,
    disableSpecialLink: !!disableSpecialLink,
    showExpandIcon: showExpandIcon,
    className: (0, _clsx3.default)((0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('article-detail-richtext__nofaq'), isSeparate)),
    uiOptimisationAccordionOptions: uiOptimisationAccordionOptions,
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableModal: isUIOptimisationTable
  }), !isSeparate && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('article-detail-content-faq')
  }, /*#__PURE__*/_react.default.createElement(FAQList, {
    disabledFaq: disabledFaq,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: trackingData,
    useUIOptimisationRecommender: useUIOptimisationRecommender
  }))));
};
exports.PopupArticle = PopupArticle;